import range from "lodash/range";
import moment from "moment";

//United States first and order the rest alphabetically
let countries = [
  "Andorra",
  "Canada",
  "Finland",
  "Iceland",
  "Liechtenstein",
  "Monaco",
  "San Marino",
  "Spain",
  "Australia",
  "Chile",
  "France",
  "Italy",
  "Lithuania",
  "Netherlands",
  "Singapore",
  "Sweden",
  "Austria",
  "Czech Republic",
  "Germany",
  "Ireland",
  "Luxembourg",
  "New Zealand",
  "Slovakia",
  "Switzerland",
  "Belgium",
  "Denmark",
  "Greece",
  "Japan",
  "Malta",
  "Norway",
  "Slovenia",
  "Taiwan",
  "Brunea",
  "Estonia",
  "Hungary",
  "Latvia",
  "Mexico",
  "Portugal",
  "South Korea",
  "United Kingdom",
  "Bermuda",
];
countries.sort();
countries = ["United States", ...countries];
export { countries };

export const states = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const months = [
  { value: 1, label: "01 - January" },
  { value: 2, label: "02 - February" },
  { value: 3, label: "03 - March" },
  { value: 4, label: "04 - April" },
  { value: 5, label: "05 - May" },
  { value: 6, label: "06 - June" },
  { value: 7, label: "07 - July" },
  { value: 8, label: "08 - August" },
  { value: 9, label: "09 - September" },
  { value: 10, label: "10 - October" },
  { value: 11, label: "11 - November" },
  { value: 12, label: "12 - December" },
];

export const days = range(1, 32).map((value) => ({
  value: value,
  label: `0${String(value)}`.slice(-2),
}));

const startYear = moment().subtract(100, "years").toDate().getFullYear();
const stopYear = moment().subtract(20, "years").toDate().getFullYear();

export const years = range(startYear, stopYear);

//start and stop years for minor users
export const minorYears = range(
  moment().subtract(22, "years").toDate().getFullYear(),
  moment().subtract(14, "years").toDate().getFullYear()
);

export const idTypes = [
  "Drivers License",
  "Passport",
  "State ID Card",
  "Other",
];



// WEBPACK FOOTER //
// ./src/common/utils.js